export const convertCurrencyToNumber = (currencyString: string) => {
  return Number(currencyString.replace(/[^0-9.-]+/, ''));
};
